var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.486 4.486 0 10 0C12.227 0 14.3348 0.716476 16.0956 2.072L13.7718 5.09067C12.683 4.25257 11.3788 3.80952 10 3.80952C6.58657 3.80952 3.80952 6.58657 3.80952 10C3.80952 13.4134 6.58657 16.1905 10 16.1905C12.7492 16.1905 15.0855 14.3892 15.8907 11.9048H10V8.09524H20V10C20 15.514 15.514 20 10 20C4.486 20 0 15.514 0 10Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_36"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.f5374f8168eed0ffc295c8b2bbdefbf8.svg";
export { ForwardRef as ReactComponent };